import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/close.png'
import _imports_1 from '../assets/close-img.png'


const _withScopeId = n => (_pushScopeId("data-v-428873d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "snapRecord" }
const _hoisted_2 = { class: "snapRecordList" }
const _hoisted_3 = { class: "snapRecordListBox" }
const _hoisted_4 = { class: "block" }
const _hoisted_5 = {
  key: 0,
  class: "show-imgs"
}
const _hoisted_6 = { class: "catch-time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_image = _resolveComponent("a-image")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "close-img",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeSnapRecordF && _ctx.closeSnapRecordF(...args)))
        }),
        _createVNode(_component_a_table, {
          dataSource: _ctx.dataList?.result,
          columns: _ctx.columns,
          pagination: false,
          scroll: { y: 430 }
        }, {
          bodyCell: _withCtx(({ column, record, index }) => [
            (column.title === _ctx.t('serialnumber'))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(index + 1), 1)
                ], 64))
              : _createCommentVNode("", true),
            (column.title === _ctx.t('operate'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  onClick: ($event: any) => (_ctx.getImgUrls(record.snap_pic_list, record.snap_time)),
                  type: "text",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("view")), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_pagination, {
            "show-size-changer": "",
            "show-quick-jumper": "",
            "show-total": 
              (totalNum) => `${_ctx.t('intotal')} ${totalNum} ${_ctx.t('article')}`
            ,
            pageSize: _ctx.requestObj.size,
            "onUpdate:pageSize": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.requestObj.size) = $event)),
            total: _ctx.totalNum,
            size: "small",
            onChange: _ctx.handleCurrentChange
          }, null, 8, ["show-total", "pageSize", "total", "onChange"])
        ])
      ])
    ]),
    (_ctx.showImg)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.t("capturetime")) + "：" + _toDisplayString(_ctx.catchTime), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgUrls, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "img-item",
              key: index
            }, [
              _createVNode(_component_a_image, {
                style: {"width":"300px","height":"300px"},
                src: item,
                "preview-src-list": [item]
              }, null, 8, ["src", "preview-src-list"])
            ]))
          }), 128)),
          _createElementVNode("img", {
            src: _imports_1,
            class: "close-showImg",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeImgF && _ctx.closeImgF(...args)))
          })
        ]))
      : _createCommentVNode("", true)
  ], 512)), [
    [_vShow, _ctx.showSnapRecord]
  ])
}